<div class="sdc-log">
  <div class="sdc-log-page">
    <div class="log-header">
      <div class="id-line">
        <strong>#{{ sdcLog.id }}</strong>
        <small class="meta">Created {{
            sdcLog.creationDate | gpDate:{withTime: true, timezone: timezone}
          }}</small>
        <small class="meta">Updated {{
            sdcLog.updateDate | gpDate:{withTime: true, timezone: timezone}
          }}</small>
      </div>
    </div>
    <div class="log-scroll">
      <div class="row">
        <div class="col-sm-6">
          <p>
            <strong>Employee Id:</strong> {{ sdcLog.employeeId }}<br>
            <strong>Employee Other Id:</strong> {{ sdcLog.employeeOtherId1 }}<br>
            <strong>Employee Begin/End:</strong> {{ sdcLog.employeeBeginDate }}-{{ sdcLog.employeeEndDate }}<br>
            <strong>Contract Id:</strong>
            <a [routerLink]="['/employees/files', sdcLog.contractId]"
               target="_blank"
               class="link">{{ sdcLog.contractId }}</a>
          </p>
        </div>
        <div class="col-sm-6">
          <p>
            <strong>Event Type:</strong> {{ sdcLog.eventType }}<br>
            <strong>Status:</strong> {{ sdcLog.status }}<br>
            <strong>Correlation Id:</strong> {{ sdcLog.correlationId }}<br>
            <strong>Pay group:</strong> {{ sdcLog.payGroup }}
          </p>
        </div>
        <div class="col-sm-12">
          <label class="block-label">Message:</label>
          <textarea class="full-width" readonly>{{ sdcLog.message }}</textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 block">
          <div>
            <span>Sent data</span>
            <copy-to-clipboard
              [data]="getPrettyJson(sdcLog.jsonSent)"
              [toolTipMessageBefore]="'Copy sent data'"
              [toolTipMessageAfter]="'Sent data copied'">
            </copy-to-clipboard>
          </div>
          <textarea class="full-width code" readonly>{{ getPrettyJson(sdcLog.jsonSent) }}</textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 block">
          <div>
            <span>Response</span>
            <copy-to-clipboard
              [data]="getPrettyJson(sdcLog.httpRespBody)"
              [toolTipMessageBefore]="'Copy response'"
              [toolTipMessageAfter]="'Response copied'">
            </copy-to-clipboard>
          </div>
          <textarea class="full-width code" readonly>{{ getPrettyJson(sdcLog.httpRespBody) }}</textarea>
        </div>
      </div>
      <div class="row" *ngIf="sdcLog.context">
        <div class="col-sm-12 block">
          <div>
            <span>Context</span>
            <copy-to-clipboard
              [data]="getPrettyJson(sdcLog.context)"
              [toolTipMessageBefore]="'Copy context'"
              [toolTipMessageAfter]="'Context copied'">
            </copy-to-clipboard>
          </div>
          <textarea class="full-width code" readonly>{{ getPrettyJson(sdcLog.context) }}</textarea>
        </div>
      </div>
      <div class="row" *ngIf="sdcLog.eventType === SdcEventTypes.SDC3">
        <div class="col-sm-12 block">
          <strong>Person logs:</strong>
          <div class="nested-scroll">
            <gp-person-payroll-logs-list [sdcLogId]="sdcLog.id?.toString()"
                                         [sdcLogType]="SdcEventTypes.SDC3"></gp-person-payroll-logs-list>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="sdcLog.eventType === SdcEventTypes.SDC3_PAYROLL_INPUT">
        <div class="col-sm-12 block">
          <strong>Payroll logs:</strong>
          <div class="nested-scroll">
            <gp-person-payroll-logs-list [sdcLogId]="sdcLog.id?.toString()"
                                         [sdcLogType]="SdcEventTypes.SDC3_PAYROLL_INPUT"></gp-person-payroll-logs-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
